import { graphql } from "gatsby"
import React from "react"
import Seo from "../components/templates/SEO"
import Hero from "../components/molecules/Hero"
import DienstenOverzicht from "../components/molecules/DienstenOverzicht"
import InHetKort from "../components/molecules/InHetKort"
import KlantLogos from "../components/molecules/KlantLogos"
import Galerij from "../components/molecules/Galerij"
import Reviews from "../components/molecules/Reviews"
import Kennismaken from "../components/molecules/Kennismaken"
import Blogs from "../components/molecules/Blogs"
import DienstenArchive from "../components/molecules/DienstenArchive"
import ProjectenArchive from "../components/molecules/ProjectenArchive"
import TeamledenOverzicht from "../components/molecules/TeamledenOverzicht"
import OverOnsInfo from "../components/molecules/OverOnsInfo"
import Support from "../components/molecules/Support"
import Contactgegevens from "../components/molecules/Contactgegevens"
import PageTransition from "../components/molecules/PageTransition"
import TekstContent from "../components/molecules/TekstContent"

export default function PageTemplate({ data, pageContext }) {
  return (
    <PageTransition>
      <div>
        {data.wpPage.paginas.blocks.map(block => {
          console.log(block)
          if (block.blok == "hero") {
            return <Hero block={block} pageData={pageContext} />
          } else if (block.blok == "diensten") {
            return (
              <DienstenOverzicht
                view={"grid"}
                block={block.dienstenOverzicht}
              />
            )
          } else if (block.blok == "in het kort") {
            return <InHetKort block={block} />
          } else if (block.blok == "logos") {
            return <KlantLogos block={block.logos} />
          } else if (block.blok == "galerij") {
            return <Galerij block={block.galerij} />
          } else if (block.blok == "reviews") {
            return <Reviews block={block.reviews} />
          } else if (block.blok == "kennismaken") {
            return <Kennismaken block={block.kennismaken} />
          } else if (block.blok == "blog overzicht") {
            return <Blogs block={block.blogOverzicht} />
          } else if (block.blok == "dienstenArchive") {
            return <DienstenArchive block={block.dienstenArchive} />
          } else if (block.blok == "projectenArchive") {
            return <ProjectenArchive block={block.projectenArchive} />
          } else if (block.blok == "teamledenOverzicht") {
            return <TeamledenOverzicht block={block.teamledenOverzicht} />
          } else if (block.blok == "overOnsInfo") {
            return <OverOnsInfo block={block.overOnsInfo} />
          } else if (block.blok == "support") {
            return <Support block={block.support} />
          } else if (block.blok == "contactgegevens") {
            return <Contactgegevens block={block.contactgegevens} />
          } else if (block.blok == "content") {
            return <TekstContent block={block.content} />
          }
        })}
      </div>
    </PageTransition>
  )
}

export const Head = ({ data }) => <Seo src={data.wpPage.seo} />

export const pageQuery = graphql`
  query ($id: Int!) {
    wpPage(databaseId: { eq: $id }) {
      seo {
        title
        metaDesc
        metaRobotsNofollow
        metaRobotsNoindex
        canonical
        opengraphType
        opengraphTitle
        opengraphDescription
        opengraphUrl
        opengraphSiteName
        opengraphPublishedTime
        opengraphModifiedTime
        twitterTitle
        twitterDescription
        opengraphAuthor
        readingTime
        twitterImage {
          mediaItemUrl
        }
        schema {
          raw
        }
        opengraphPublisher
        metaKeywords
      }
      paginas {
        blocks {
          blok
          hero {
            title
            description
            callToAction {
              label
              link
            }
            callToAction2 {
              label
              link
              icon {
                localFile {
                  publicURL
                }
              }
              afbeelding {
                localFile {
                  childImageSharp {
                    gatsbyImageData
                  }
                }
              }
            }
            afbeelding {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
              }
            }
            label
          }
          dienstenOverzicht {
            titel
          }
          inHetKort {
            label
            tekst
            titel
            link
          }
          content {
            title
            content
          }
          logos {
            logo {
              logo {
                localFile {
                  childImageSharp {
                    gatsbyImageData
                  }
                }
              }
            }
          }
          galerij {
            afbeeldingen {
              afbeelding {
                localFile {
                  childImageSharp {
                    gatsbyImageData
                  }
                }
              }
            }
          }
          reviews {
            titel
          }
          kennismaken {
            titel
            tekst
            subtitel
            afbeelding {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
              }
            }
            cta {
              label
              link
            }
          }
          blogOverzicht {
            titel
          }
          dienstenArchive {
            titel
          }
          projectenArchive {
            titel
          }
          overOnsInfo {
            tekstvlak
          }
          teamledenOverzicht {
            titel
            tekst
            subtitel
          }
          support {
            supportBlok {
              tekst
              cta
              titelIcon {
                titel
                icon {
                  localFile {
                    publicURL
                  }
                }
              }
            }
            supportBlok2 {
              tekst
              cta
              titelIcon {
                titel
                icon {
                  localFile {
                    publicURL
                  }
                }
              }
            }
            supportBlok3 {
              tekst
              cta
              titelIcon {
                titel
                icon {
                  localFile {
                    publicURL
                  }
                }
              }
            }
          }
          contactgegevens {
            titel
            formulierId
            subtitel
            tekst
            email {
              link
              label
              icon {
                localFile {
                  publicURL
                }
              }
            }
            telefoonnummer {
              label
              link
              icon {
                localFile {
                  publicURL
                }
              }
            }
            whatsapp {
              label
              link
              icon {
                localFile {
                  publicURL
                }
              }
            }
          }
        }
      }
    }
  }
`
